import { useWithinStoryPage } from 'src/hooks/use-within-story-page';
import { PERMISSION_GROUPS_LIMIT } from 'src/pages/settings/organisation/users/details/assign-permissions/use-page-params';
import * as pp from 'src/utils/page-params';

export function usePageParams() {
  const withinStoryPage = useWithinStoryPage();
  return pp.usePageParams(
    pp
      .configure()

      .add(pp.start('start'))
      .add(
        pp
          .number('pageSize')
          .default(withinStoryPage ? 20 : PERMISSION_GROUPS_LIMIT)
      )
  );
}

export type PageParams = ReturnType<typeof usePageParams>;
